import React, { ButtonHTMLAttributes } from 'react';
import { useHistory } from 'react-router-dom';
import { IconSvg } from '../IconSvg';
import { Preloader } from '../Preloader';
import {
  Container,
  Inner,
  Icon,
  ButtonCover,
  IconCenterWrapper,
  iconSvg,
  buttonCover
} from './styles';

import type { ButtonProps, Template, ViewType } from './types';

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const {
    view = 'primary',
    size = 'M',
    shape = 'default',
    isHover = true,
    iconPosition = 'left',
    icon,
    onClick,
    ...other
  } = props;

  const history = useHistory();

  const defineComponent = () => {
    if (props.as) return props.as;
    if (props.href || props.to) return 'a';
    return undefined;
  };

  const defineType = (): ButtonHTMLAttributes<HTMLButtonElement>['type'] => {
    if ((!props.to && !props.href && !props.as) || props.as === 'button') return 'button';
    return undefined;
  };

  const defineView = (): ViewType | Template => {
    if (props.isDisabled) return 'disabled';
    if (props.isSuccess) return 'success';
    return view;
  };

  const clickHandler = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (props.to && !props.as) {
      e.preventDefault();
      history.push(props.to);
    }
    onClick && onClick(e);
  };

  return (
    <Container
      ref={ref}
      as={defineComponent()}
      href={props.to}
      type={defineType()}
      view={defineView()}
      size={size}
      shape={shape}
      disabled={props.isDisabled || props.isLoading}
      isHover={isHover}
      onClick={clickHandler}
      {...other}
    >
      <Inner isHidden={props.isLoading || props.isSuccess}>
        {icon && (iconPosition === 'left' || iconPosition === 'left-auto') && (
          <Icon position={iconPosition}>{icon}</Icon>
        )}
        {props.children}
        {icon && (iconPosition === 'right' || iconPosition === 'right-auto') && (
          <Icon position={iconPosition}>{icon}</Icon>
        )}
      </Inner>

      {props.isSuccess && !props.isLoading && (
        <IconCenterWrapper>
          <IconSvg src="check" css={iconSvg} />
        </IconCenterWrapper>
      )}
      {props.isLoading && (
        <IconCenterWrapper>
          <Preloader css={iconSvg} />
        </IconCenterWrapper>
      )}
    </Container>
  );
});

export { Container as ButtonEmotion, ButtonCover, buttonCover };
export type { ButtonProps, Template as ButtonTemplate, ViewType as ButtonViewType };
